import { Box, styled } from "@mui/material";

import { Link } from "react-router-dom";
import EcoLogo from "../../../assets/eco-logo-footer.png";
import { Text } from "../../Typography";

const debug = true;

export const AppTitle = ({ white }: any) => (
  <Link to={"/"} style={{ textDecoration: "none" }}>
    {debug ? (
      <Box sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "4px"
      }}>
        {/* <EfLogo /> */}
        <Text sx={{ fontWeight: 900, color: white ? "common.white" : "text.primary", fontSize: "16px" }}>EcoFutures</Text>
      </Box>
    ) : (
      <StyledTitle>
        <img src={EcoLogo} alt="EcoFutures" />
      </StyledTitle>
    )}
  </Link>
);

const StyledTitle = styled("div")`
  padding: 0 16px;
  font-size: 25px;
  font-weight: 500;
  text-decoration: none;
  color: white;
`;

// const EfLogo = createSvgIcon(
//   <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <circle cx="15" cy="15" r="13.5" stroke="black" strokeWidth="3" />
//     <path d="M15.333 7.00391C16.3281 8.63964 17.8589 10.2327 19.9512 11.7393V12.9658C18.1652 12.2771 16.7876 11.5881 15.8945 10.8994V11.918C16.8755 13.283 18.2383 14.6132 20 15.8818V17.1094C19.9837 17.1031 19.9674 17.0961 19.9512 17.0898V17.2705C18.1968 16.594 16.8374 15.9158 15.9434 15.2393V16.291C16.9129 17.6254 18.265 18.9382 20 20.1865V21.4141C18.2141 20.7254 16.8364 20.0363 15.9434 19.3477V22.1348H14.1309V21.0342H14.083V19.3809C13.1889 20.0379 11.8289 20.7373 10.0488 21.4141V20.1865C11.756 18.9583 13.1161 17.646 14.083 16.3125V15.2041C13.19 15.8713 11.8116 16.5818 10 17.2705V16.0439C10.0165 16.0321 10.0324 16.0187 10.0488 16.0068V15.8818C11.7682 14.6437 13.1077 13.3471 14.083 12.0166V10.8994C13.19 11.5666 11.8116 12.2771 10 12.9658V11.7393C12.0922 10.2327 13.6231 8.63957 14.6182 7.00391H15.333Z" fill="black" />
//   </svg>
//   , "EcoFuturesLogo");
